var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMusicLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#fff",
    stroke: "#E5E8EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    d: "M49.8254 27.9498H56.4588V51.1666H49.8254V27.9498Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2BCDE4",
    d: "M56.4593 51.1666C56.4593 55.746 52.747 59.4583 48.1677 59.4583C43.5883 59.4583 39.876 55.746 39.876 51.1666C39.876 46.5872 43.5883 42.8749 48.1677 42.8749C52.747 42.8749 56.4593 46.5872 56.4593 51.1666Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    d: "M24.9504 31.2667H31.5838V54.4834H24.9504V31.2667Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2BCDE4",
    d: "M24.9504 25.5385C24.9504 24.0623 26.0244 22.8054 27.4826 22.5752L52.9909 18.5476C54.8118 18.2601 56.4588 19.6674 56.4588 21.5109V31.2667L24.9504 36.2417V25.5385Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2BCDE4",
    d: "M31.5834 54.4834C31.5834 59.0628 27.8711 62.7751 23.2917 62.7751C18.7123 62.7751 15 59.0628 15 54.4834C15 49.904 18.7123 46.1917 23.2917 46.1917C27.8711 46.1917 31.5834 49.904 31.5834 54.4834Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    d: "M64.751 51.1664H71.3843V74.3831H64.751V51.1664Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#2BCDE4",
    d: "M64.751 44.569C64.751 43.5913 65.4578 42.757 66.4222 42.5962L81.1578 40.1403C82.9864 39.8355 84.651 41.2456 84.651 43.0995V50.2834C84.651 51.7499 83.5908 53.0015 82.1442 53.2426L64.751 56.1415V44.569Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2BCDE4",
    d: "M71.3839 74.3831C71.3839 78.9625 67.6716 82.6748 63.0922 82.6748C58.5128 82.6748 54.8005 78.9625 54.8005 74.3831C54.8005 69.8037 58.5128 66.0914 63.0922 66.0914C67.6716 66.0914 71.3839 69.8037 71.3839 74.3831Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicLight);
export default __webpack_public_path__ + "static/media/music-light.74a143cbe555d346d311e3d65ec66c6a.svg";
export { ForwardRef as ReactComponent };